import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import { Icon } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ASCENDING = 'Ascending';
const DESCENDING = 'Descending';

const HeaderTd = (props) => {
  const sortClassName = classnames(styles.HeaderTd_sort, {
    [styles.__ascending]: props.sortType === ASCENDING,
    [styles.__descending]: props.sortType === DESCENDING,
  });
  const nextSortType = props.sortType === ASCENDING ? DESCENDING : ASCENDING;
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  return <td className={classnames(props.className, styles.HeaderTd,
      props.sortable ? styles.HeaderTd_sortable : '')}
      onClick={() => props.sortable && props.onSort(nextSortType)}>
    <div className={styles.HeaderTd_content}>
      <p className={styles.HeaderTd_p}>
        {props.children}
      </p>
      {
        (props.sortType === ASCENDING || props.sortType === DESCENDING) &&
        <Icon id="sorting" className={sortClassName} />
      }
    </div>
  </td>;
};

HeaderTd.propTypes = {
  sortable: PropTypes.bool,
  sortType: PropTypes.string,
  onSort: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default HeaderTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/HeaderTd/index.jsx